var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[[_c('div',{class:[
                _vm.$route.name == 'homepage' ? `home bg-${_vm.img}` : 'home-more',
                _vm.$route.name == 'send-shipment' ? `no-margin` : '',
                _vm.$route.meta.unautherized ? `no-margin` : '',
                _vm.$route.meta.publicPage ? `no-margin` : '',
                _vm.$route.meta.autherizedAndNotVerified ? `no-margin` : '',
            ]},[_c('router-view')],1)],_c('loader',{attrs:{"trigger":_vm.appLoading,"message":_vm.message}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }